import movieflick from '../assets/projects/movieflick.png'
import sack from '../assets/projects/sack.png'
import languagelab from '../assets/projects/languagelab.png'
import contour from '../assets/projects/contour.png'
import rahulprotfolio from '../assets/projects/rahulprotfolio.png'
import edufordcollege from '../assets/projects/edufordcollege.png'
import easytomake from '../assets/projects/easytomake.png'
import cardekho from '../assets/projects/cardekho.png'
import Skilllearn from '../assets/projects/skill-learn.png'
import tesla from '../assets/projects/teslaclone.png'
import bookyourroom from '../assets/projects/bookyourroom.png'
import covide from '../assets/projects/covide.png'
import fithit from '../assets/projects/fithit.png'
import marvelsh from '../assets/projects/marvelsh.png'
import moviesplus from '../assets/projects/moviesplus.png'
import acehaversack from '../assets/projects/acehaversack.png';

const ProjectCardData = [
    {
        imgsrc: movieflick,
        title: "Movie Flick",
        text: "Paragraph",
        view: "https://movieflick.netlify.app/",
        source: "https://github.com/TheRahulTiwari28/movieflick"
    },
    {
        imgsrc: Skilllearn,
        title: "Skill Learn",
        text: "Paragraph",
        view: "https://skill-learn.netlify.app/",
        source: "https://github.com/TheRahulTiwari28/skill-learn"
    },
    {
        imgsrc: sack,
        title: "Sack",
        text: "Paragraph",
        view: "https://sack.netlify.app/",
        source: "https://github.com/TheRahulTiwari28/Sack-react"
    },
    {
        imgsrc: contour,
        title: "Contour Portfolio",
        text: "Paragraph",
        view: "https://contour-1.netlify.app/",
        source: "https://github.com/TheRahulTiwari28/profile"
    },
    {
        imgsrc: rahulprotfolio,
        title: "Portfolio",
        text: "Paragraph",
        view: "https://rahulprotfolio.netlify.app/",
        source: "https://github.com/TheRahulTiwari28/Rahul-Protfolios"
    },
    {
        imgsrc: edufordcollege,
        title: "Eduford Collage",
        text: "Paragraph",
        view: "https://edufordcollege.netlify.app/",
        source: "https://github.com/TheRahulTiwari28/eduford"
    },
    {
        imgsrc: easytomake,
        title: "Easy To Make",
        text: "Paragraph",
        view: "https://easytomake.netlify.app/",
        source: "https://github.com/TheRahulTiwari28/recipes"
    },
    {
        imgsrc: cardekho,
        title: "Car Dekho",
        text: "Paragraph",
        view: "https://cardekho.netlify.app/",
        source: "https://github.com/TheRahulTiwari28/CarDekho"
    },
    {
        imgsrc: languagelab,
        title: "Language Lab",
        text: "Paragraph",
        view: "https://languagelab.netlify.app/",
        source: "https://github.com/TheRahulTiwari28/codelab"
    },
    {
        imgsrc: tesla,
        title: "Tesla",
        text: "Paragraph",
        view: "https://tesla-clone-1.netlify.app/",
        source: "https://github.com/TheRahulTiwari28/tesla-clone"
    },
    {
        imgsrc: bookyourroom,
        title: "Book Your Room",
        text: "Paragraph",
        view: "https://bookyourroom.netlify.app/",
        source: "https://github.com/TheRahulTiwari28/resort"
    },
    {
        imgsrc: covide,
        title: "Covide",
        text: "Paragraph",
        view: "https://covide-19.netlify.app/",
        source: "https://github.com/TheRahulTiwari28/covide-19"
    },
    {
        imgsrc: fithit,
        title: "Fihit",
        text: "Paragraph",
        view: "https://fithit.netlify.app/",
        source: "https://github.com/TheRahulTiwari28/fitness"
    },
    {
        imgsrc: marvelsh,
        title: "MarvelSh",
        text: "Paragraph",
        view: "https://marvelsh.netlify.app/",
        source: "https://github.com/TheRahulTiwari28/marvel"
    },
    {
        imgsrc: moviesplus,
        title: "Moves Plus",
        text: "Paragraph",
        view: "https://moviesplusx.netlify.app/",
        source: "https://github.com/TheRahulTiwari28/movies-"
    },
    {
        imgsrc: acehaversack,
        title: "AceHaverSack",
        text: "Paragraph",
        view: "https://acehaversack.netlify.app/",
        source: "https://github.com/TheRahulTiwari28/acehaversack"
    }
]

export default ProjectCardData